import { createRoot } from "react-dom/client";
import React from "react";
import elementService from "../../../../js/common/ElementService";
import { assert } from "../../../../js/common/assert";
import InsertBasketApp from "./InsertBasketApp";

export default new class InsertProductToBasketService {
    public init(): void {
        this.initInContainer(document.body);
    }

    public initInContainer(container: HTMLElement): void {
        this.initInsertToBasketButtons(container);
    }

    public showPopup(productId: number): void {
        const popupContainer = document.createElement("div");
        const root = createRoot(popupContainer);

        document.body.appendChild(popupContainer);

        root.render(<InsertBasketApp
            productId={productId}
            onClose={(): void => {
                root.unmount();
                popupContainer.remove();
            }}
        />);
    }

    private initInsertToBasketButtons(container: HTMLElement): void {
        for (const addProductToBasketButton of container.querySelectorAll<HTMLButtonElement>(".js-add-product-to-basket")) {
            addProductToBasketButton.addEventListener("click", () => this.addProductToBasket(addProductToBasketButton));
        }
    }

    private addProductToBasket(addProductToBasketButton: HTMLButtonElement): void {
        this.showPopup(this.readProductIdFromButton(addProductToBasketButton));
    }

    private readProductIdFromButton(button: HTMLButtonElement): number {
        const productId = Number.parseInt(elementService.elementData(button, "productId"));

        assert(!Number.isNaN(productId));

        return productId;
    }
}();
